import { useShowContext } from 'framework/show';
import { EMPTY_VALUE_INDICATOR, getValue, getLabel } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';
import useFieldHelper from '../fieldHelper';
import { BaseFieldLayoutType, FieldProps } from '../types';

const NumberField = ({ source = '', value, label, displayZeroValue = true }: FieldProps<number>) => {
  const { data } = useShowContext();
  const { getValue: getValueFromFieldHelper } = useFieldHelper({ source });
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const getFieldValue = () => {
    const valueFromShowContext = getValue(value, (src?: string) => data && data.getValueBySource(src!), source);

    if (valueFromShowContext) {
      return displayZeroValue && valueFromShowContext === EMPTY_VALUE_INDICATOR ? '0' : valueFromShowContext;
    }

    return displayZeroValue && !getValueFromFieldHelper() ? '0' : getValueFromFieldHelper();
  };

  return <BaseFieldLayout label={getLabel(label, source)} value={getFieldValue()} />;
};

export default NumberField;
